import { FC, useCallback } from "react";
import { useAppSelector } from "toolkit/hooks";
import { TableItem } from "../TableItem/TableItem";
import styles from "./TableBody.module.sass";
import { useLocation } from "react-router-dom";

export const TableBody: FC = () => {
	const { objectsRegisterList, searchedData, searchMode } = useAppSelector((state) => state.objectsRegister);

	const location = useLocation();
	const className = useCallback(
		(id: number) => {
			return location.state?.outline === id ? styles.outline : "";
		},
		[location.state],
	);
	return (
		<tbody data-comment-false={true} className={styles.body}>
			{!searchMode && objectsRegisterList.map((obj) => <TableItem className={className} object={obj} key={obj.id} />)}
			{searchMode && searchedData.map((obj) => <TableItem className={className} object={obj} key={obj.id} />)}
		</tbody>
	);
};
